<template lang="pug">
    router-view
</template>

<script>
export default {
    name: 'main',
    props: {},
    data: function(){
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>